window.copyToClipboard = function (text, flash) {
    let promise = navigator.clipboard.writeText(text);

    promise.then(function() {
        if (flash) {
            flashNotify(flash);
        }
    }, function() {
        console.error('Clipboard error')
    });
};